import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { map, retry } from 'rxjs/operators';
import { Report } from '../interfaces/report';
import { Survey } from '../interfaces/qualtrics';
import { environment } from '@environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { API_URIS } from '@shared/constants/api-uris.const';
import { PCV2Request } from '@shared/interfaces/request.interface';
import { adaptResponseToSource } from '../adapters/keiron.adapter';
import { OrderKeironResponse, ParamsToFindSurgeriesData } from '../interfaces/keiron.interface';

const SURVEY_ID: string = 'SV_0pvn4EPl6QhyBgO';
const BASE_API_PCV2: string = environment.baseApiPCv2;
const URI_KEIRON_SURGERY_STATUS: string = API_URIS.keiron.statusOrderV2;

export interface QueryQualtrics {
  dateTo: string,
  dateFrom: string,
  specialities: string[]
  professionalRut: string,
}

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getReportByDate(date: string): Observable<Report> {
    return this.httpClient.get<PCV2Request>(`${BASE_API_PCV2}/agenda/v1/reporte/${date}`).pipe(
      retry(3),
      map(({data}: { data: Report }) => data),
    );
  }

  getCurrentReport(): Observable<Report> {
    return this.httpClient.get<PCV2Request>(`${BASE_API_PCV2}/agenda/v1/reporte/actual`).pipe(
      retry(3),
      map(({data}: { data: Report }) => data),
    );
  }

  getValueQualtrics(query: QueryQualtrics): Observable<Survey> {
    const {dateFrom, dateTo, specialities, professionalRut} = query
    const upperCaseSpecialities = specialities.map(speciality => speciality.toUpperCase());

    const params = new HttpParams()
      // .set('especialidades', JSON.stringify(upperCaseSpecialities))
      .set('dateFrom', dateFrom)
      .set('dateTo', dateTo);


    const url = `${BASE_API_PCV2}/analitica/v1/encuestas/${SURVEY_ID}/profesionales/${professionalRut}`;
    return this.httpClient.get<PCV2Request>(url, {params}).pipe(retry(3), map(({data}) => data as Survey));

  }

  /**
   * Obtiene el estado de las cirugías desde el sistema Keiron según los parámetros proporcionados.
   *
   * Realiza una solicitud HTTP GET al endpoint correspondiente, utilizando los datos de búsqueda
   * (fecha de inicio, fecha de fin y RUT del doctor) para filtrar los resultados. La respuesta se adapta
   * al formato esperado por la aplicación.
   *
   * @param formData Objeto que contiene los parámetros de búsqueda: fecha de inicio (`start`), fecha de fin (`end`) y RUT del doctor (`rut`).
   * @returns Un observable que emite un arreglo de respuestas de tipo `OrderKeironResponse[]` con el estado de las cirugías.
   */
  public getSurgeriesStatusFromKeiron(formData: ParamsToFindSurgeriesData): Observable<OrderKeironResponse[]> {
    const {start: startDate, end: endDate, rut: rut_doctor} = formData;
    const params = `?rut_doctor=${encodeURIComponent(rut_doctor)}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&page=1&limit=100`;
    return this.httpClient.get<PCV2Request>(`${BASE_API_PCV2}/${URI_KEIRON_SURGERY_STATUS}${params}`).pipe(
      retry(3),
      map(({data}) => adaptResponseToSource(data)),
    );
  }
}
